import React from 'react'

function Career() {
  return (
         <>
      {/* HERO AREA STARTS */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Career Opportunities</h1>
                <div className="space28"></div>
                <a href="index.html">
                  Home <i className="fa-solid fa-angle-right"></i> <span>Careers</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* HERO AREA ENDS */}

      {/* JOBS AREA STARTS */}
      <div className="vl-blog-4-area-inner sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="vl-blog-1-item">
                <div className="vl-blog-1-thumb image-anime">
                  <img src="assets/img/all-images/blog/blog-img15.png" alt="" />
                </div>
                <div className="vl-blog-1-content">
                  <div className="vl-blog-meta">
                    <ul>
                      <li><a href="#"><img src="assets/img/icons/calender3.svg" alt="" /> Full-Time | On-site</a></li>
                    </ul>
                  </div>
                  <div className="space16"></div>
                  <h4 className="vl-blog-1-title"><a href="https://docs.google.com/forms/d/e/1FAIpQLSd0zkba5Olqd4W5AOPLRjMuTu0Wbtwr0VjFyCa7Ft90FSSm0A/viewform?usp=dialog">Quality Assurance Engineer - Automation Testing</a></h4>
                  <div className="space20"></div>
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSd0zkba5Olqd4W5AOPLRjMuTu0Wbtwr0VjFyCa7Ft90FSSm0A/viewform?usp=dialog" className="readmore">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="vl-blog-1-item">
                <div className="vl-blog-1-thumb image-anime">
                  <img src="assets/img/all-images/blog/blog-img16.png" alt="" />
                </div>
                <div className="vl-blog-1-content">
                  <div className="vl-blog-meta">
                    <ul>
                      <li><a href="#"><img src="assets/img/icons/calender3.svg" alt="" /> Full-Time | Remote</a></li>
                    </ul>
                  </div>
                  <div className="space16"></div>
                  <h4 className="vl-blog-1-title"><a href="https://docs.google.com/forms/d/e/1FAIpQLSd0zkba5Olqd4W5AOPLRjMuTu0Wbtwr0VjFyCa7Ft90FSSm0A/viewform?usp=dialog">Database Administrator - Performance & Security Expert</a></h4>
                  <div className="space20"></div>
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSd0zkba5Olqd4W5AOPLRjMuTu0Wbtwr0VjFyCa7Ft90FSSm0A/viewform?usp=dialog" className="readmore">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* JOBS AREA ENDS */}
    </> 
  )
}

export default Career;
